<script setup lang="ts">
import { onMounted, watch, nextTick, computed, ref } from "vue";
import { useLanguage } from "../utils/useLanguage";
import { useVideoLoader } from "../utils/videoPlayer/useVideoLoader";
import { usePlayer } from "../utils/videoPlayer/usePlayer";
import { useVideoController } from "../utils/videoPlayer/useVideoController";
import { useNotebook } from "../utils/videoPlayer/useNotebook";
import { usePlayerUI } from "../utils//videoPlayer/usePlayerUI";
import { isLogin, checkLoginStatus } from "../utils/useAuth";
import { useUserStore } from "../store/userStore";
import { useRoute } from "vue-router";
const userStore = useUserStore();

const route = useRoute();

let videoId = route.params.id as string;

// const videoId = "a3dabb9f-72ac-4b84-a352-6ecc877ec30b"
// const videoId = "0d739329-4aea-4545-a612-84914a885d4c"
// const isLogin = !!localStorage.token
// 僅載入影片並根據來源嵌入播放器

const RecommendedVideos = ref()
const RECOMMENDED_VIDEOS_CN = "58ed503e-eee6-4f54-ac5d-2f0fe357e53c"; // Production
const RECOMMENDED_VIDEOS_SP = "047e0417-9976-4f1c-a386-e6e379886c27"; // Production
const RECOMMENDED_VIDEOS_EN = "435fcdc1-da33-490c-95bd-ca741e86dbdb"; // Production
// const RECOMMENDED_VIDEOS_CN = "e3c42a6a-e414-4dfd-9c6f-a2cdba436cbf"; // Jani
// const RECOMMENDED_VIDEOS_SP = "43fd0369-0ec4-43b4-a994-f2652f71de8c"; // Jani
// const RECOMMENDED_VIDEOS_EN = "4b4849e2-8328-4f7f-99df-031d5e2c2d94"; // Jani

const recommendedVideoId = computed<string>(() => {
  if (learning_language.value === "Spanish") return RECOMMENDED_VIDEOS_SP;
  if (learning_language.value === "English") return RECOMMENDED_VIDEOS_EN;
  return RECOMMENDED_VIDEOS_CN; // Simplified_Chinese / default
});

// const RecommendedVideosCN = ref('e3c42a6a-e414-4dfd-9c6f-a2cdba436cbf')//Jani[CN]
// const RecommendedVideosSP = ref('43fd0369-0ec4-43b4-a994-f2652f71de8c')//Jani[SP]
// const RecommendedVideosEN = ref('4b4849e2-8328-4f7f-99df-031d5e2c2d94')//Jani[EN]
const learning_language = computed(
  () => userStore.learning_language || localStorage.getItem("learningLanguage") || "Simplified_Chinese"
);


const site_language = ref();

const { t } = useLanguage();

// 使用自定義 type 載入影片資料
const {
  videoTranscript,
  videoType,
  originId,
  videoLang,
  getVideo,
  download_transcripts,
} = useVideoLoader();

const { saveSt, lookup, saveVb, vocabularyData, loadingInfo, modalInfo } =
  useNotebook(
    videoId,
    isLogin.value,
    videoLang,
    learning_language,
    site_language
  );

// 使用播放器 composable
const {
  handleAudioClick,
  getVoice,
  formatDuration,
  mute,
  createYouTubePlayer,
  createVimeoPlayer,
  createAwsPlayer,
  toggleVideo,
  handleProgressBarClick,
  startDragging,
  handleDrag,
  stopDragging,
  updateProgress,
  videoCt,
  videoYt,
  vimeo,
  progressWidth,
  cSpeed,
  canChangeSpeed,
  muteStatus,
  videoState,
} = usePlayer();

const {
  fullScreen,
  alignScript,
  newWidth,
  full,
  single,
  align,
  addEventListeners,
} = usePlayerUI();

const {
  openNote,
  openVideo,
  openHistory,
  openCC,
  toggleVmodal,
  toggleNbook,
  toggleHistory,
  toggleCC,
} = useVideoController(videoYt, vimeo);

watch(videoTranscript, async (newVal) => {
  if (newVal && newVal.length > 0) {
    await nextTick(); // 等 DOM 完整渲染

    const sentenceElements = document.querySelectorAll(".sentence");

    let accumulatedHeight = 0;

    sentenceElements.forEach((el, index) => {
      videoTranscript.value[index].ht = accumulatedHeight;
      // 加上當前這句的高度 + 間距（10px），供下一句使用
      accumulatedHeight += el.clientHeight + 10;
    });

    console.log("✅ 已設定 ht", videoTranscript.value);
  }
});

const currentSub = ref();
watch(
  () => videoCt.value,
  () => {
    if (!videoTranscript.value || videoTranscript.value.length === 0) {
      console.warn("⚠️ videoTranscript is empty or not ready.");
      return;
    }

    const subtitle = document.getElementById("subtitle") as HTMLElement;
    const sentence = document.querySelectorAll(".sentence");
    let accumulatedHeight = 0;

    videoTranscript.value.forEach((item, i) => {
      const isActive = item.start < videoCt.value && videoCt.value < item.end;
      item.state = isActive && videoState.value;

      if (isActive) {
        currentSub.value = item.id;

        // 計算要滾動的高度（前面幾句的總高）
        for (let j = 0; j < i; j++) {
          accumulatedHeight += sentence[j]?.clientHeight + 10 || 0;
        }

        subtitle.scrollTop = accumulatedHeight;
      }
    });
  }
);

const playerContainer = ref<HTMLElement | null>(null);


async function reloadVideo(targetId: string) {
  await getVideo(targetId);
  console.log('getVideo(targetId)',targetId)
  await nextTick();
  
  if (videoType.value === "Youtube" && playerContainer.value) {
    createYouTubePlayer(originId.value, () => {});
    console.log('originId.value',originId.value)
  } else if (videoType.value === "Vimeo") {
    createVimeoPlayer(originId.value);
  } else if (videoType.value === "AWS") {
    createAwsPlayer(originId.value);
  }
}

watch(
  () => learning_language.value,
  async () => {
    if (!isLogin.value) return;
    if (route.path !== "/video") return;

    videoId = recommendedVideoId.value; // 更新目前 videoId
    console.log(videoId)
    await reloadVideo(videoId);
  }
);

const isInternalEnglish = computed(() => {
  const ll = (learning_language.value ?? "").trim()
  const email = (userStore.email ?? "").trim().toLowerCase()
  return ll === "English" && email.endsWith("@mimir.com")
})

onMounted(async () => {
  //await 只能在 async 函式內部
  checkLoginStatus();
  if (!isLogin.value) return;

  // learning_language.value = localStorage.getItem("learningLanguage");
  site_language.value = localStorage.getItem("siteLanguage");

  if (route.path === "/video") {
    videoId = recommendedVideoId.value;
    await reloadVideo(videoId);
  } else {
    await reloadVideo(videoId);
  }

  await nextTick(); // 等待 DOM 完整渲染

  if (videoType.value === "Youtube" && playerContainer.value) {
    createYouTubePlayer(originId.value, () => {});
  } else if (videoType.value === "Vimeo") {
    createVimeoPlayer(originId.value);
  } else if (videoType.value === "AWS") {
    createAwsPlayer(originId.value);
  }

  //   addEventListeners()
});
</script>

<template>
  <section class="container-title">
    <div>
      <div class="flex column-sm">
        <div
          class="rel i-flex column col-3"
          :class="{ full: fullScreen, align: alignScript }"
        >
          <div
            id="video"
            class="rel v-contain flex column"
            :class="videoState ? 'active' : ''"
          >
            <div
              ref="playerContainer"
              id="player"
              class="v-frame bg-black-1"
            ></div>
            <div
              class="toolbar flex j-between a-center gap-20 bg-white-2 abs"
              style="left: 0; top: 10px; z-index: 99"
            >
              <div class="i-flex gap-10">
                <span
                  :name="t('Mute')"
                  :class="muteStatus ? 'icon-voice' : 'icon-mute'"
                  class="pt pointer md rel"
                  @click="mute"
                ></span>
                <!-- <span
                  :name="t('Upload Video')"
                  class="pt icon-video-sync-fill md pointer rel"
                  @click="toggleVmodal"
                ></span> -->
                <span
                  :name="t('Download captions')"
                  class="pt icon-download md pointer rel"
                  @click="download_transcripts"
                ></span>
                <span
                  :name="t('Notes')"
                  class="pt icon-notebook md pointer rel"
                  @click="toggleNbook"
                ></span>
                <span
                  :name="t('Look Up History')"
                  class="pt icon-search md pointer rel"
                  @click="toggleHistory"
                ></span>
                <span
                  :name="t('Subtitles')"
                  class="pt icon-subtitles md pointer rel"
                  @click="toggleCC"
                ></span>

                <div
                  v-if="canChangeSpeed"
                  :name="t('Speed')"
                  class="pt black i-flex a-center j-center bold pointer rel fs-075r"
                  @click="getVoice(cSpeed)"
                >
                  {{ cSpeed }}x
                </div>

                <span
                  :name="t('Captions Side by side')"
                  class="pt icon-split md-none md pointer rel"
                  @click="align(alignScript)"
                  v-if="fullScreen"
                ></span>
                <span
                  :name="t('Exit Theater')"
                  class="pt icon-close-circle md pointer rel"
                  @click="single"
                  v-if="fullScreen"
                ></span>
              </div>
            </div>
            <div class="v-mask abs" @click="toggleVideo">
              <div class="abs p-center flex column gap-10 a-center">
                <span
                  id="video-button"
                  :class="
                    videoState
                      ? 'v-pause icon-pause-filled'
                      : 'v-play icon-play'
                  "
                ></span>
              </div>
            </div>
            <div class="v-transcript-cover abs" v-if="openCC">
              <span
                class="icon-close-circle md pointer white-1 abs"
                style="right: 0; top: 0"
                @click="openCC = false"
              ></span>
              <ul class="flex column a-center gap-10">
                <li
                  class="flex a-center gap-20"
                  :style="currentSub == item.id ? '' : 'display: none'"
                  v-for="(item, index) in videoTranscript"
                  :key="index"
                  :data-start="item.start"
                  :data-end="item.end"
                  :data-height="item.ht"
                >
                  <div class="i-flex a-center column">
                    <p class="t-zh i-flex j-center wrap font-2">
                      <span
                        class="cat title-1 white-1"
                        v-for="(word, index) in item.zh_text"
                        :key="index"
                        @click="lookup(item.id, word, videoId)"
                        >{{ word }}</span
                      >
                    </p>
                    <p
                      class="t-en title-1 white-1"
                      :class="item.en_text.length > 50 ? 'title-1' : 'title-2'"
                      style="line-height: 16px"
                    >
                      {{ item.en_text }}
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div id="subtitle" class="transcript lg bg-black">
            <ul class="flex column gap-10" style="margin-top: 28px">
              <li
                class="sentence flex a-center gap-20"
                v-for="(item, index) in videoTranscript"
                :key="index"
                :data-start="item.start"
                :data-end="item.end"
                :data-height="item.ht"
              >
                <p class="t-zh i-flex j-center wrap gap-5 font-2 mb-5">
                  <span class="font-4 white">{{
                    formatDuration(item.start)
                  }}</span>
                  <span
                    class="s-audio pointer white"
                    :class="item.state ? 'icon-pause-filled' : 'icon-play'"
                    @click="handleAudioClick(item, index)"
                  ></span>
                  <span
                    :id="'st' + item.id"
                    class="icon-heart-circle-filled md pointer"
                    @click="saveSt(item, videoId)"
                  ></span>
                </p>
                <div class="i-flex column" style="width: calc(100% - 132px)">
                  <p
                    class="t-zh i-flex j-center wrap font-2"
                    :class="[item.state ? 'active bg-dark-200' : '']"
                  >
                    <span
                      class="cat white"
                      v-for="(word, index) in item.zh_text"
                      :key="index"
                      @click="lookup(item.id, word, videoId)"
                      >{{ word }}</span
                    >
                  </p>
                  <p
                    class="t-en white t-center"
                    :class="item.en_text.length > 50 ? 'font-3' : 'font-2'"
                    style="line-height: 16px"
                  >
                    {{ item.en_text }}
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div
            class="flex column gap-5 mb-10 bg-white-1 p-20 p-center"
            :class="fullScreen ? 'fixed' : 'abs'"
            style="z-index: 999999"
            v-if="vocabularyData.text"
          >
            <h3 class="title-3 bold i-flex a-center gap-5">
              {{ vocabularyData.text }}
              <span
                :id="'vb' + vocabularyData.id"
                class="icon-heart-circle-filled md pointer"
                :class="vocabularyData.user_saved ? 'dark' : ''"
                @click="saveVb(vocabularyData)"
                v-if="vocabularyData.id"
              ></span>
            </h3>
            <p class="black-3 font-2" >{{ vocabularyData.pronunciation }}</p>
            <p>{{ vocabularyData.meaning }}</p>
            <p class="black-3 font-4" v-if="vocabularyData.language === 'Simplified_Chinese'">
              {{ t('dictionarySource') }}:
              <a href="https://cc-cedict.org/wiki/" target="_blank" rel="noopener">CC-CEDICT</a> (CC BY-SA 4.0)
            </p>
            <span
              class="black-2 icon-close pointer abs"
              style="top: 5px; right: 5px"
              @click="vocabularyData.text = ''"
            ></span>
          </div>
          <div
            class="controlbar flex j-between a-center gap-20 mt-20 bg-black-2"
            :class="fullScreen ? 'full' : ''"
          >
            <div class="i-flex gap-10">
              <span
                :name="t('Theater Mode')"
                class="pt icon-full pointer white-2 rel"
                @click="full"
              ></span>
              <span
                :name="t('Mute')"
                :class="muteStatus ? 'icon-voice' : 'icon-mute'"
                class="pt pointer white-2 rel"
                @click="mute"
              ></span>
              <span
                :class="videoState ? 'icon-pause-filled' : 'icon-play'"
                class="pointer white-2"
                @click="toggleVideo"
              ></span>
            </div>
            <div
              id="progressbar"
              class="progressbar rel pointer"
              @click="handleProgressBarClick"
              @mousedown="startDragging"
              @mousemove="handleDrag"
              @mouseup="stopDragging"
            >
              <div
                id="v-progress"
                class="v-progress bg-dark abs"
                :style="{ width: progressWidth }"
              ></div>
            </div>
            <div
              v-if="canChangeSpeed"
              :name="t('Speed')"
              class="pt v-speed black i-flex a-center j-center bold pointer rel"
              @click="getVoice(cSpeed)"
            >
              {{ cSpeed }}x
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <videoBox v-model:status="openVideo.status"></videoBox>
  <notesBox v-model:status="openNote.status"></notesBox>
  <historyBox v-model:status="openHistory.status"></historyBox>
  <Loading v-model:status="loadingInfo.status" v-model:title="loadingInfo.title" ></Loading>
  <Modal v-model:type="modalInfo.type" v-model:title="modalInfo.title" v-model:content="modalInfo.content" v-model:status="modalInfo.status" v-model:msg="modalInfo.msg"/>

</template>

<style scoped>
@import "../assets/css_lib/themimir.css";

#player .ytp-pause-overlay,
#player .ytp-ce-element {
  display: none !important;
}

.full #player > div {
  padding: 0;
  height: 100%;
}
.v-contain {
  position: relative;
  padding-bottom: 56%;
  /* padding-top: 30px; */
  height: 0;
  overflow: hidden;
  margin-right: 5px;
  border-radius: 15px;
}
@media all and (max-width: 540px) {
  .v-contain {
    border-radius: 20px;
  }
}
.v-frame,
.v-frame iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.t-zh.active > *:not([class^=".icon"]) {
  font-weight: bold;
  color: #0d0d0d;
}

.sentence {
  min-height: 40px;
}

@media all and (max-width: 540px) {
  .sentence {
    border-top: 1px dashed #f2f2f2;
    padding-top: 10px;
  }
}
.t-zh > .s-audio::before {
  font-size: 20px;
  color: #828282;
  opacity: 0.3;
}

.t-zh.active > .s-audio:before,
.t-zh > .s-audio:hover::before {
  opacity: 1;
  color: #9747ff;
}
.t-en {
  font-style: italic;
}
.cat {
  padding: 0 2px;
}
.cat:hover {
  font-weight: bold;
  color: #9747ff;
  cursor: pointer;
}
.video {
  max-width: 100%;
}

.transcript {
  height: 250px;
  overflow-y: scroll;
}
@media all and (min-width: 768px) {
  .transcript {
    height: 100px;
    padding: 0 40px;
  }
}
.transcript > li.active .t-zh > span {
  font-weight: bold;
}

.controlbar {
  width: 100%;
  height: 50px;
  padding: 10px 25px;
  border-radius: 50px;
}
.toolbar {
  padding: 10px 25px;
  border-radius: 0 50px 50px 0;
  opacity: 0.5;
  transition: all 0.5s ease-in;
}
.toolbar:hover {
  opacity: 1;
}
.active .controlbar {
  background: rgba(0, 0, 0, 0.7);
}
.v-transcript-cover {
  width: 90%;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px 20px;
  background: #00000070;
  z-index: 100;
}
.v-progress,
.progressbar {
  width: 100%;
  height: 10px;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.5);
}
.v-progress {
  width: 10%;
}
.v-vector {
  max-width: 30%;
  width: 250px;
  top: -70px;
  right: -15px;
  z-index: 6;
}
.v-speed {
  width: 40px;
  height: 25px;
  background: #fff;
  font-size: 12px;
  border-radius: 2px;
}
.v-mask {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #000000;
  transition: all 0.5s;
  opacity: 0.9;
}
.active > .v-mask {
  opacity: 0.1;
  pointer-events: none;
}
.v-play,
.v-pause {
  font-size: 70px;
  opacity: 0.2;
}
.v-play:before,
.v-pause:before {
  color: #ffffff;
}
.v-play:hover,
.v-pause:hover {
  cursor: pointer;
  opacity: 0.7;
}

.full:not(.align) .v-mask,
.full:not(.align) .v-frame {
  width: 100vw;
  height: 100vh;
}
.full .v-contain {
  position: fixed;
  z-index: 999999;
  left: 0;
  top: 0;
  border-radius: 0;
  width: 100vw;
  height: 100vh;
  padding: 0;
  border-right: 1px solid;
}
.full .v-transcript-cover {
  height: calc((100vh - 100vw * 0.67) / 2);
}
.full .progressbar {
  position: fixed;
  z-index: 1000000;
  left: 0;
  bottom: 0;
}
.full.align .v-frame {
  width: 100%;
}
.full.align .v-contain {
  width: 75vw;
}
.full.align .transcript {
  height: 100vh !important;
  position: fixed;
  right: 0;
  z-index: 999999;
  top: 0;
  width: 25vw;
  background: black;
  padding: 20px;
}
@media (orientation: landscape) {
  .full .v-transcript-cover {
    height: auto;
  }
}

.videoBox {
  width: 400px;
  max-width: 90%;
  bottom: 0;
  right: 20px;
  display: none;
}
.videoBox.open {
  display: block;
}
.videoBox > .modalTitle {
  padding: 5px 15px;
}
.videoBox > .modalContent {
  max-height: 350px;
  padding: 10px;
}

.videoItem {
  padding: 10px;
}
.videoItem:hover {
  background: #fbf7f4;
}

.cover.sm.vcover {
  padding-bottom: 56.25%;
  border-radius: 15px;
}

.underline {
  border-bottom: 20px solid transparent;
  background-image: url("/watch_title_underline_pink.png");
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: 100% auto;
  padding-bottom: 20px; /* Adjust to match the height of the border */
}
.underline.yellow {
  background-image: url("/watch_title_underline_yellow.png");
}
@media all and (max-width: 768px) {
  .underline {
    padding-bottom: 15px; /* Adjust to match the height of the border */
  }
}
.pt:hover::after {
  display: block;
}
.pt::after {
  content: attr(name);
  display: none;
  padding: 3px 5px;
  background: #b780ff;
  color: white;
  position: absolute;
  top: calc(100% + 2px);
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
}

.full.align .transcript .white {
  color: var(--white-4);
}

.full.align .transcript .cat:hover {
  font-weight: bold;
  color: var(--pr);
  cursor: pointer;
}
</style>
